import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Form, InputGroup} from "react-bootstrap";
import axios from "axios";
import {validatePhoneNumber} from "../../utils";
import AvailableStates from "../../common/states.json";

export const PatientDetailsView = forwardRef((props: { category: string, uhid: string, postAction: any, isCustomerView?: boolean, isClientView?: boolean, updateEvents?: any }, ref) => {

    const [formData, updateFormData] = useState({gender: "MALE"});
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [name, setName] = useState<string>();
    const [options, setOptions] = useState<Array<any>>();
    const [mobile, setMobile] = useState<string>();
    const [uhid, setUhid] = useState<string>(null);
    const [extUhid, setExtUhid] = useState<string>(null);
    const [availableStates, setAvailableStates] = useState<Array<string>>(AvailableStates);

    const [role, setRole] = useState<string>(null)

    useEffect(() => {
        // Perform localStorage action
        setRole(localStorage.getItem('role'))
    }, [])


    const handleChange = (e) => {
        setSuccessMessage("")
        setErrorMessage("")
        updateFormData({
            ...formData,
            // Trimming any whitespace
            [e.target.name]: e.target.value
        });
    };

    function fetchEvents() {
        axios.get('/api/backend/customers/fetch/QME-' + uhid + '/events')
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                if (props.updateEvents) {
                    props.updateEvents(resp.data)
                }
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }

    useEffect(() => {
        if (uhid != null) {
            fetchEvents()
            axios.get('/api/backend/customers/fetch/QME-' + uhid)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    if (resp.data == "") {
                        updateFormData({gender: "MALE"})
                        setName(null)
                        setExtUhid(null)
                        setMobile(null)
                    } else {
                        updateFormData(resp.data)
                        setName(resp.data.name)
                        setMobile(resp.data.mobile)
                        setExtUhid(resp.data.extUhid)
                    }
                })
                .catch(err => {
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                })
        }
    }, [uhid])

    useEffect(() => {
        if (extUhid != null) {
            axios.get('/api/backend/customers/fetch/external/' + extUhid)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    if (resp.data != "") {
                        updateFormData(resp.data)
                        setName(resp.data.name)
                        setMobile(resp.data.mobile)
                        setUhid(resp.data.uhid.split("-")[1])
                    }
                })
                .catch(err => {
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                })
        }
    }, [extUhid])

    useEffect(() => {
        if (mobile != null) {
            axios.get('/api/backend/customers/fetch/all/' + mobile)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    if (resp.data == "") {
                        setUhid(null)
                    } else if (!uhid) {
                        setOptions(resp.data)
                    }
                })
                .catch(err => {
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                })
        }
    }, [mobile])

    useEffect(() => {
        if (props.uhid != null) {
            setUhid(props.uhid.split("-")[1])
        }
    }, [props.uhid])


    useImperativeHandle(ref, () => ({
        handleDataSubmit() {
            handleSubmit(null)
        }

    }));

    const handleSubmit = (e) => {
        if (e) {
            e.preventDefault()
        }
        if (!validatePhoneNumber(mobile) || !name) {
            setErrorMessage("* Please provide correct data")
            return
        } else {
            setErrorMessage(null)
        }
        setSuccessMessage("")
        setErrorMessage("")
        if (uhid == null || uhid == "") {
            axios.post('/api/backend/customers/create', {
                ...formData,
                name: name,
                mobile: mobile,
                extUhid: extUhid
            })
                .then(resp => {
                    props.postAction(resp.data.uhid)
                })
                .catch(err => {
                    setErrorMessage("* Something went wrong! Please try again in some time.")
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                    ;
                });
        } else {
            axios.post('/api/backend/customers/update', {
                ...formData,
                uhid: "QME-" + uhid,
                name: name,
                mobile: mobile,
                extUhid: extUhid
            })
                .then(resp => {
                    props.postAction("QME-" + uhid)
                })
                .catch(err => {
                    setErrorMessage("* Something went wrong! Please try again in some time.")
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                    ;
                });
        }
    };

    const handleSelectPatient = (option) => {
        setUhid(option.uhid.split("-")[1])
        setOptions([])
    };

    function getPetFormData() {
        return <>
            <div className="row">
                {!props.uhid && <>
                    <div className="col col-12 col-lg-12">
                        <Form.Group className="mb-3" controlId="formUhid">
                            <Form.Label className="fs-7 text-secondary">UHID</Form.Label>
                            <div className="d-flex gap-2">
                                <span className="fs-7 text-nowrap align-self-center">Qme -</span>
                                <Form.Control value={uhid ? uhid : ""} onChange={e => setUhid(e.target.value)}
                                              name="uhid"
                                              type="text" size={"sm"}
                                              placeholder="Enter UHID if Available"/>
                            </div>
                        </Form.Group>
                    </div>
                    {!props.isCustomerView && <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="formExtUhid">
                            <Form.Label className="fs-7 text-secondary">External UHID</Form.Label>
                            <Form.Control value={extUhid ? extUhid : ""} onChange={e => setExtUhid(e.target.value)}
                                          name="extUhid" type="text" size={"sm"}
                                          placeholder="Enter External UHID if Available"/>
                        </Form.Group>
                    </div>}
                </>}
                {props.uhid && <div className="col col-12 col-lg-12 mb-3">UHID : {props.uhid}</div>}
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formPhone">
                        <Form.Label className="fs-7 text-secondary">Phone no.<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={mobile ? mobile : ""} onChange={e => setMobile(e.target.value)}
                                      name="mobile" type="text" size={"sm"}
                                      placeholder="Enter Phone Number"/>
                    </Form.Group>
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formName">
                        <Form.Label className="fs-7 text-secondary">Pet Name<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={name ? name : ""} onChange={e => setName(e.target.value)} name="name"
                                      type="text" size={"sm"}
                                      placeholder="Enter Pet Name"/>
                    </Form.Group>
                    {options && options.length > 0 &&
                        <div className="mb-3">
                            {options.map((o) => {
                                return <Form.Check
                                    key={o}
                                    label={o.name}
                                    name="options"
                                    type={"radio"}
                                    checked={name == o}
                                    onChange={() => handleSelectPatient(o)}
                                />
                            })}
                        </div>
                    }
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formFather">
                        <Form.Label className="fs-7 text-secondary">Owner&apos;s name<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={formData['fatherName'] ? formData['fatherName'] : ""}
                                      onChange={handleChange} name="fatherName" type="text" size={"sm"}
                                      placeholder="Enter Owner's name"/>
                    </Form.Group>
                </div>

                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formPetAge">
                        <Form.Label className="fs-7 text-secondary">Pet Age</Form.Label>
                        <Form.Control value={formData['age'] ? formData['age'] : ""} onChange={handleChange} name="age"
                                      type="text" size={"sm"}
                                      placeholder="Enter pet age"/>
                    </Form.Group>
                </div>

                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formPetGender">
                        <Form.Label className="fs-7 text-secondary">Pet Gender</Form.Label>
                        <Form.Control value={formData['gender'] ? formData['gender'] : ""} onChange={handleChange}
                                      name="gender" type="text" size={"sm"}
                                      placeholder="Enter pet gender"/>
                    </Form.Group>
                </div>

                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formAddress">
                        <Form.Label className="fs-7 text-secondary">Address</Form.Label>
                        <Form.Control value={formData['address'] ? formData['address'] : ""} onChange={handleChange}
                                      name="address" as="textarea" size={"sm"}
                                      rows={2}
                                      placeholder="Enter Address"/>
                    </Form.Group>
                </div>

            </div>
        </>;
    }


    function getPatientFormData() {
        return <>
            <div className="row">
                {!props.uhid && <>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="formUhid">
                            <Form.Label className="fs-7 text-secondary">UHID</Form.Label>
                            <div className="d-flex gap-2">
                                <span className="fs-7 text-nowrap align-self-center">QMe -</span>
                                <Form.Control value={uhid ? uhid : ""} onChange={e => setUhid(e.target.value)}
                                              name="uhid" type="text" size={"sm"}
                                              placeholder="Enter UHID if Available"/>
                            </div>
                        </Form.Group>
                    </div>
                    {!props.isCustomerView && <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="formExtUhid">
                            <Form.Label className="fs-7 text-secondary">Hospital/Clinic UHID</Form.Label>
                            <Form.Control value={extUhid ? extUhid : ""} onChange={e => setExtUhid(e.target.value)}
                                          name="extUhid" type="text" size={"sm"}
                                          placeholder="Enter Hospital/Clinic UHID if Any"/>
                        </Form.Group>
                    </div>}
                </>}
                {props.uhid && <div className="col col-6 col-lg-12 mb-3">UHID : {props.uhid}</div>}
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formPhone">
                        <Form.Label className="fs-7 text-secondary">Phone no.<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={mobile ? mobile : ""} onChange={e => setMobile(e.target.value)}
                                      name="mobile" type="text" size={"sm"}
                                      placeholder="Enter Phone Number"/>
                    </Form.Group>
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formName">
                        <Form.Label className="fs-7 text-secondary">Name<span
                            className="text-danger">*</span></Form.Label>
                        <Form.Control value={name ? name : ""} onChange={e => setName(e.target.value)} name="name"
                                      type="text" size={"sm"}
                                      placeholder="Enter Name"/>
                    </Form.Group>
                    {options && options.length > 0 &&
                        <div className="mb-3">
                            {options.map((o) => {
                                return <Form.Check
                                    key={o}
                                    label={o.name}
                                    name="options"
                                    type={"radio"}
                                    checked={name == o}
                                    onChange={() => handleSelectPatient(o)}
                                />
                            })}
                        </div>
                    }
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formAge">
                        <Form.Label className="fs-7 text-secondary">Age</Form.Label>
                        <Form.Control value={formData['age'] ? formData['age'] : ""} onChange={handleChange} name="age"
                                      type="tel" size={"sm"}
                                      placeholder="Enter age in years"/>
                    </Form.Group>
                </div>

                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formGender">
                        <Form.Label className="fs-7 text-secondary">Gender</Form.Label>
                        <Form.Select onChange={handleChange} value={formData['gender']} name="gender" size={"sm"}>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Transgender">Transgender</option>
                            <option value="Other">Other</option>
                        </Form.Select>
                    </Form.Group>
                </div>
                {props.category == "IPD" && <>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="formFather">
                            <Form.Label className="fs-7 text-secondary">Father&apos;s name:</Form.Label>
                            <Form.Control value={formData['fatherName'] ? formData['fatherName'] : ""}
                                          onChange={handleChange} name="fatherName" type="text" size={"sm"}
                                          placeholder="Enter Father's name"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="formMother">
                            <Form.Label className="fs-7 text-secondary">Mother&apos;s name:</Form.Label>
                            <Form.Control value={formData['motherName'] ? formData['motherName'] : ""}
                                          onChange={handleChange} name="motherName" type="text" size={"sm"}
                                          placeholder="Enter Mother's name"/>
                        </Form.Group>
                    </div>
                </>}
                <div className="col col-12 col-lg-6">
                    <Form.Group className="mb-3" controlId="formAddress">
                        <Form.Label className="fs-7 text-secondary">Address</Form.Label>
                        <Form.Control value={formData['address'] ? formData['address'] : ""} onChange={handleChange}
                                      name="address" as="textarea" size={"sm"}
                                      rows={5}
                                      placeholder="Enter Address"/>
                    </Form.Group>
                </div>
                <div className="col col-12 col-lg-6">
                    <Form.Label className="fs-7 text-secondary">State:</Form.Label>
                    <select className="form-select form-select-sm" name="state"
                            value={formData['state'] ? formData['state'] : ""}
                            onChange={handleChange}
                    >
                        {availableStates.map((s) => {
                            return <option key={s} value={s}>{s}</option>
                        })}
                    </select>

                    <Form.Group className="my-3" controlId="formDist">
                        <Form.Label className="fs-7 text-secondary">District:</Form.Label>
                        <Form.Control value={formData['district'] ? formData['district'] : ""}
                                      onChange={handleChange}
                                      name="district" type="text" size={"sm"}
                                      placeholder="Enter District"/>
                    </Form.Group>
                </div>
            </div>
        </>;
    }

    return (
        <>
            <Form>
                {props.category == "Veterinarian" && getPetFormData()}
                {props.category != "Veterinarian" && getPatientFormData()}

                {successMessage &&
                    <div className="text-success fs-7 my-4">{successMessage}</div>
                }
                {errorMessage &&
                    <div className="text-danger fs-7 my-4">{errorMessage}</div>
                }
            </Form>
        </>
    );
});

PatientDetailsView.displayName = "PatientdataView";